import { render, staticRenderFns } from "./FormOfPaymentList.vue?vue&type=template&id=040cb1c4"
import script from "./FormOfPaymentList.vue?vue&type=script&lang=js"
export * from "./FormOfPaymentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports